import React from 'react';
import { connect } from 'react-redux';
import { setShowThankModal } from '../../redux/testPage/testPage.actions';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const KidsThankYouModal = ({
	setShowThankModal,
	showThankModal,
	activeChildId,
	history,
	elementType,
}) => {
	const redirectToDashboard = () => {
		setShowThankModal(false);
	};
	return (
		<Modal
			show={showThankModal}
			size="lg"
			dialogClassName="modal-90w"
			onHide={() => setShowThankModal(false)}
			backdrop={true}
			keyboard={false}
			className="thankyou-popup"
			id="thankyou-popup"
		>
			<Modal.Header closeButton>
				<h4 className="modal-title">
					{elementType === 'W'
						? "Great! You've finished one practice set."
						: `Great! You've finished the STEPathon Junior Test.`}
				</h4>
			</Modal.Header>
			<Modal.Body size="lg">
				<div className="row">
					<div className="col-lg-12 col-xs-12 text-center">
						<p>
							{elementType === 'W'
								? `Now that you know how the test would look like, you can attempt the final STEPathon Junior Test! `
								: `You can now view your report from your dashboard. The report has also been sent to your parent's Email ID/Phone Number.`}
						</p>
						<a
							href={
								localStorage.getItem('juniorAccount') === 'true'
									? '/junior/dashboard'
									: `child/dashboard/${activeChildId}`
							}
							style={{ cursor: 'pointer' }}
						>
							<Button
								aria-label="continue"
								className="btn-primarycol-centered"
								style={{ cursor: 'pointer' }}
								onClick={redirectToDashboard}
							>
								Continue
							</Button>
						</a>
					</div>
				</div>
			</Modal.Body>

			<Modal.Footer></Modal.Footer>
		</Modal>
	);
};

const mapDispatchToProps = (dispatch) => {
	return {
		setShowThankModal: (val) => dispatch(setShowThankModal(val)),
	};
};

const mapStateToProps = (state) => {
	const { showThankModal, elementType } = state.rootReducer.testPageDetails;
	const { activeChildId } = state.rootReducer.parentDetails;
	return {
		activeChildId,
		showThankModal,
		elementType,
	};
};

export default withRouter(
	compose(connect(mapStateToProps, mapDispatchToProps)(KidsThankYouModal)),
);
